/** 全局轻提示和确认对话框，由 App 挂载一次；页面里调用 core/session 的 toast() / confirm() */
import { CircleAlert, CircleCheck } from "lucide-react";
import { createPortal } from "react-dom";
import { answerConfirm, dismissToast, useSession } from "../core/session";
import { Button } from "./Button";
import { Sheet } from "./Sheet";

export function ToastHost() {
  const t = useSession((s) => s.toast);
  if (!t) return null;
  return createPortal(
    <div className="kp-toast-host" aria-live="polite">
      <div key={t.id} className={`kp-toast ${t.error ? "is-error" : ""}`} onClick={dismissToast} role={t.error ? "alert" : "status"}>
        {t.error ? <CircleAlert size={18} color="var(--kp-danger-soft)" /> : <CircleCheck size={18} color="var(--kp-success-soft)" />}
        <span>{t.text}</span>
      </div>
    </div>,
    document.body,
  );
}

export function ConfirmDialog() {
  const c = useSession((s) => s.confirm);
  return (
    <Sheet open={!!c} onClose={() => answerConfirm(false)} width={400} label={c?.title}>
      {c && (
        <div className="kp-confirm">
          <h2>{c.title}</h2>
          {c.message && <p>{c.message}</p>}
          <div className="kp-confirm-actions">
            <Button variant="soft" onClick={() => answerConfirm(false)}>
              {c.cancelText}
            </Button>
            <Button variant={c.danger ? "danger" : "dark"} onClick={() => answerConfirm(true)} autoFocus>
              {c.confirmText}
            </Button>
          </div>
        </div>
      )}
    </Sheet>
  );
}
